'use client';

import { ErrorState } from '@/lib/components/error/error-state';
import { useErrorReport } from '@/lib/components/error/use-error-report';
import { useClerk } from '@clerk/nextjs';

// Catches routes that sit outside the project shell (/admin, /onboarding, auth pages).
// No shell to keep, so the wordmark goes in the page corner. Sign out is offered here
// because at this level the session itself is a plausible cause - it is not on Tier 2.
export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const referenceId = useErrorReport(error, 'root-error-boundary');
  const { signOut } = useClerk();

  return (
    <div className="relative flex min-h-screen flex-col">
      <ErrorState
        tier="route"
        kind="error"
        title="Something went wrong"
        description="Something went wrong on our side. Your data is safe and nothing was changed."
        brandMark
        primaryAction={{ label: 'Try again', onClick: () => reset() }}
        secondaryAction={{ label: 'Sign out', onClick: () => void signOut({ redirectUrl: '/' }) }}
        referenceId={referenceId}
        support="balder"
      />
    </div>
  );
}
